import {} from "../env/index.js";
import {} from "./Parameter.js";
import { formatParameter } from "./formatParameter.js";
export function formatParameters(env, parameters) {
    return parameters
        .map((parameter) => formatParameter(env, parameter))
        .join(", ");
}
//# sourceMappingURL=formatParameters.js.map